import cn from 'classnames'
import PropTypes from 'prop-types'

const Checkbox = ({
  id,
  label,
  subtext,
  defaultChecked,
  checked,
  className,
  onChange,
  disabled,
}) => {
  return (
    <label className={cn('checkbox-with-label', '-checkbox', className)}>
      <input
        className="checkbox-with-label__input"
        id={id}
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        type="checkbox"
      />
      <div
        className={cn('checkbox-with-label__checkbox', {
          '-disabled': disabled,
        })}
      />
      {renderLabelAndSubtext(label, subtext)}
    </label>
  )
}

const renderLabelAndSubtext = (label, subtext) => {
  if (subtext) {
    return (
      <div>
        <div className="top-label">{label}</div>
        <div className="bottom-label">{subtext}</div>
      </div>
    )
  }

  return (
    <div>
      <div className="top-label">{label}</div>
    </div>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  subtext: PropTypes.string,
  defaultChecked: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default Checkbox
